var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPigeon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.9,
    x2: 461.376,
    y1: 138.165,
    y2: 152.635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab172"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.286,
    x2: 444.437,
    y1: 140.398,
    y2: 98.715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffed82"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab172",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009145"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.433,
    x2: 462.25,
    xlinkHref: "#lg1",
    y1: 113.033,
    y2: 100.789
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3ced"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.063,
    x2: 185.892,
    xlinkHref: "#lg2",
    y1: 84.195,
    y2: 168.452
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.013,
    x2: 148.889,
    xlinkHref: "#lg2",
    y1: 382.902,
    y2: 366.526
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3ced",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f43bb"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.383,
    x2: 199.349,
    xlinkHref: "#lg3",
    y1: 312.325,
    y2: 289.762
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.986 .166 -.166 .986 51.003 -27.352)",
    gradientUnits: "userSpaceOnUse",
    x1: 129.595,
    x2: 301.528,
    xlinkHref: "#lg2",
    y1: 347.979,
    y2: 542.225
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18cefb"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.986 .166 -.166 .986 51.003 -27.352)",
    gradientUnits: "userSpaceOnUse",
    x1: 155.893,
    x2: 110.908,
    xlinkHref: "#lg4",
    y1: 390.156,
    y2: 310.618
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.184,
    x2: 282.111,
    xlinkHref: "#lg2",
    y1: 122.604,
    y2: 437.941
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.972,
    x2: 243.298,
    xlinkHref: "#lg4",
    y1: 189.902,
    y2: 121.027
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.832,
    x2: 235.731,
    xlinkHref: "#lg3",
    y1: 278.517,
    y2: 218.417
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.575,
    x2: 81.954,
    xlinkHref: "#lg2",
    y1: 129.69,
    y2: 364.181
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.828,
    x2: 173.553,
    xlinkHref: "#lg4",
    y1: 192.119,
    y2: 36.84
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.997,
    x2: 399.095,
    xlinkHref: "#lg2",
    y1: 70.729,
    y2: 70.729
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.593,
    x2: 313.324,
    xlinkHref: "#lg4",
    y1: 143.83,
    y2: 64.96
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.771,
    x2: 311.167,
    xlinkHref: "#lg4",
    y1: 185.13,
    y2: 126.028
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.94,
    x2: 154.956,
    xlinkHref: "#lg3",
    y1: 231.828,
    y2: 28.387
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.997,
    x2: 192.064,
    y1: 158.417,
    y2: 138.098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3ced",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#3d3de7",
    stopOpacity: 0.262
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5953,
    stopColor: "#383fd8",
    stopOpacity: 0.595
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9658,
    stopColor: "#3043be",
    stopOpacity: 0.966
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f43bb"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.227,
    x2: 446.495,
    xlinkHref: "#lg1",
    y1: 176.456,
    y2: 140.549
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m450.75 230.106-19.042-93.991c-.165-.812.068-1.654.626-2.267l48.767-53.535c1.534-1.683 4.194.254 3.063 2.23l-32.645 57.021c-.242.422-.36.903-.342 1.389l3.345 88.701c.089 2.344-3.307 2.749-3.772.452z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m482.757 85-31.24 54.57-13.9 25.7-5.29-26.1c0-.01 0-.01.01-.02l48.76-53.53c.49-.54 1.1-.7 1.66-.62z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m460.332 103.114-2.595 2.849 8.28 8.28 6.371-11.129z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m217.352 272.789-116.412-264.342c-2.447-5.557 3.967-10.814 8.935-7.323l252.665 177.528c5.767 4.052 5.508 12.683-.492 16.382l-132.357 81.596c-4.426 2.728-10.243.918-12.339-3.841z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m192.87 249.488-95.201 145.109c-4.532 6.908-3.709 16.029 1.987 22.013l86.571 90.954c4.693 4.931 13.009 1.906 13.437-4.888l13.338-211.576z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m211.395 316.602 1.607-25.501-1.85-3.825-23.029 6.054z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m173.881 251.148-117.904 127.353c-5.613 6.063-6.31 15.194-1.683 22.039l70.324 104.027c3.812 5.64 12.514 4.033 14.061-2.597l49.59-209.964z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m138.679 501.97 49.589-209.963-10.598-30.096-109.789 118.587c-5.613 6.063-6.31 15.194-1.683 22.039l70.005 103.556c1.169-1.007 2.071-2.388 2.476-4.123z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m395.976 25.345-251.518 155.13c-5.69 3.51-7.797 10.759-4.874 16.772l43.546 89.572c2.554 5.254 8.295 8.163 14.042 7.115l207.972-37.895c6.188-1.127 10.685-6.518 10.685-12.807v-206.807c-.001-10.19-11.18-16.43-19.853-11.08z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m395.976 41.261-251.518 155.13c-1.464.903-2.686 2.057-3.651 3.37l42.323 87.057c2.554 5.253 8.295 8.163 14.042 7.115l207.972-37.895c6.188-1.127 10.685-6.518 10.685-12.807v-190.889c-.001-10.191-11.18-16.43-19.853-11.081z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m317.307 178.249-129.99 113.498c2.79 1.974 6.319 2.831 9.853 2.187l199.475-36.347z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m185.226 290.74-158.643-241.373c-3.335-5.074 2.118-11.322 7.597-8.704l278.61 133.163c6.36 3.04 7.535 11.594 2.232 16.236l-116.991 102.419c-3.913 3.425-9.949 2.604-12.805-1.741z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m312.79 186.96-278.61-133.163c-1.69-.808-3.377-.768-4.805-.182l155.851 237.125c2.856 4.345 8.892 5.166 12.805 1.741l116.992-102.418c.299-.262.571-.54.829-.825-.827-.916-1.849-1.698-3.062-2.278z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m415.828 35.494 57.744 57.744c4.696 4.696 1.37 12.725-5.271 12.725h-52.473z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m412.378 252.042c2.15-2.336 3.45-5.44 3.45-8.81v-206.807c0-3.331-1.208-6.226-3.119-8.446l-83.413 109.413c-.351.46-.356 1.096-.014 1.562z",
    fill: "url(#SVGID_15_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m329.282 138.954-190.148 47.956c-1.243 3.256-1.179 6.988.449 10.337l43.546 89.572c2.554 5.253 8.295 8.163 14.042 7.115l207.972-37.895c2.872-.523 5.372-1.973 7.234-3.997z",
    fill: "url(#SVGID_16_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m318.115 180.512-124.604 12.668c-1.906.194-3.351 1.809-3.331 3.725l1.006 97.61c.035.033.054.051.089.084l2.44-.107c1.541-.24 3.041-.897 4.315-2.012l116.992-102.418c2.891-2.53 3.843-6.221 3.093-9.55z",
    fill: "url(#SVGID_17_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m27.617 41.596c-2.034 1.829-2.872 4.975-1.034 7.771l158.643 241.373c1.419 2.158 3.622 3.445 5.961 3.775l-1.024-99.407c-.01-1.013-.435-1.977-1.175-2.669z",
    fill: "url(#SVGID_18_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m437.615 165.271 13.135 64.835c.465 2.296 3.861 1.891 3.772-.45l-3.345-88.701c-.018-.486.1-.967.342-1.39z",
    fill: "url(#SVGID_19_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPigeon);
export default __webpack_public_path__ + "static/media/icon-pigeon.697e43c9380fac8fbd010493e13fdbb9.svg";
export { ForwardRef as ReactComponent };